<template>
  <a-layout class="menu-content">
    <a-layout-sider width="280" style="background: #fff;padding:16px 0 16px 16px">
      <menu-tree ref="menuTreeDom" @refreshTable="initTableDataSelf" @formTitle="addMenuEvent" @formNavTitle="editMenuEvent"></menu-tree>
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 16px">
      <div class="content">
        <form-input ref="formInput" @submitEvent="handleSubmit" @submitBtnEvent="handleSubmitBtn" :params="formIptTitle"></form-input>
        <div class="tableContainer">
          <a-table
            :columns="table.columns"
            :rowKey="record => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            bordered
          >
            <template slot="actions" slot-scope="text, record">
              <div class="table-operator">
                <a v-action:updateBtn v-if="isAdmin" @click="handleEdit(record)" style="margin-right:15px;">编辑</a>
                <!-- <a-divider type="vertical" /> -->
                <a-popconfirm
                  title="确定要删除此按钮吗?"
                  @confirm="handleDelete(record)">
                  <a v-action:deleteBtn v-if="isAdmin" href="javascript:;">删除</a>
                </a-popconfirm>
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </a-layout-content>
    <edit-btn-modal ref="editBtnModal" @refreshTable="initTableDataSelf"></edit-btn-modal>
  </a-layout>
</template>

<script>
import menuTree from './modules/MenuTree.vue'
import formInput from './modules/FormInput.vue'
import { getButtonList, deleteButton } from '@/api/button'
import editBtnModal from './modules/editBtnModal'
import { mapGetters } from 'vuex'

export default {
  components: {
    menuTree, formInput, editBtnModal
  },
  computed: mapGetters(['menuList', 'btnInfo', 'isAdmin']),
  watch: {
    menuList () {
      this.initTableData(this.menuList.id)
    }
  },
  data () {
    return {
      cardOption: {}, // card相关属性设置
      searchFormModel: {}, // 搜索form中的参数
      searchModel: {}, // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      selectedRows: [],
      pagination: false,
      table: {
        data: [],
        columns: [
          {
            title: 'action',
            dataIndex: 'action'
          },
          {
            title: 'method',
            dataIndex: 'method'
          },
          {
            title: 'url',
            dataIndex: 'url'
          },
          {
            title: '备注',
            dataIndex: 'remark'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        loading: false
      },
      formIptTitle: {
        formTitle: '菜单详情'
      }
    }
  },
  mounted () {
    this.initTableData(this.menuList.id)
  },
  methods: {
    addMenuEvent () {
      this.formIptTitle.formTitle = '新建菜单'
    },
    editMenuEvent () {
      this.formIptTitle.formTitle = '编辑菜单'
    },
    handleSubmit () {
      // 表单提交成功后,重新获取树的数据
      this.$refs['menuTreeDom'].queryMenuData(true)
    },
    handleSubmitBtn () {
      // 提交按钮
      console.log('接收按钮提交事件')
    },
    initTableDataSelf () {
      this.initTableData(this.menuList.id)
    },
    // 初始化表格数据
    initTableData (id) {
      if (id != undefined || id != null) {
        this.table.loading = true
        const params = {
          paging: false,
          menuId: id
        }
        // return false
        getButtonList(params).then(res => {
          if (res.status === 0) {
            this.table.loading = false
            this.table.data = res.data
          } else {
            this.$message.error('获取数据失败！')
          }
        })
      } else {
        this.table.data = []
      }
    },
    // 删除按钮
    handleDelete (model) {
      deleteButton(model.id).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData(this.menuList.id)
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 编辑按钮
    handleEdit (model) {
      this.$refs.editBtnModal.setTitle('编辑按钮')
      this.$refs.editBtnModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editBtnModal.setModel(model) // 先设置类型，再打开
      this.$refs.editBtnModal.open(true)
    },
    // 新增按钮
    handleAdd () {
      this.$refs.editBtnModal.setTitle('新增按钮')
      this.$refs.editBtnModal.setType(this.$sysInfo.MODAL_ADD) // 先设置类型，再打开
      this.$refs.editBtnModal.open(true)
    }
  }
}
</script>
<style lang="less">
  // .formContainer{
  //   background: #fff;
  //   padding: 16px;
  //   // display:flex;
  //   // flex-direction:column;
  //   // justify-content:center;
  //   // align-item:center;
  // }
  .tableContainer{
    margin-top:16px;
  }
</style>
